<script lang="ts">
  import { alerts } from "app/stores/alert";
  import { community } from "app/stores/community";
  import { page } from "$app/stores";
  import { CommunitySignUpRequestStatusEnum as CommunityStatus } from "@outverse-video/outverse-api-client-lib";

  interface State {
    communityMembership?: CommunityStatus;
    leftCommunity?: string;
  }

  // show welcome/leave message when page state changes
  $: if ($page.state) {
    const state = $page.state as State;

    if ($community.fetched && $community.name && state.communityMembership) {
      if (state.communityMembership == CommunityStatus.Approved) {
        alerts.success(`Joined ${$community.name}`);
      }
      // otherwise we don't need to tell them - they are already a member

      // clear state so we don't keep showing the same message
      history.replaceState(null, "");
    }

    if (state.leftCommunity) {
      alerts.success(`You have left ${state.leftCommunity} community`);
      // clear state so we don't keep showing the same message
      history.replaceState(null, "");
    }
  }
</script>
